module.exports = __webpack_public_path__ + "static/media/nf-loading-gradient.82d9faab.gif";